import React, { useState, useEffect } from "react";
import AdminSidebar from "./AdminCommon/AdminSidebar";
import { useDispatch, useSelector } from "react-redux";
import AdminHeader from "./AdminCommon/AdminHeader";
import { toast } from "react-toastify";
import axios from "axios";
import { Modal, Button, Table, Dropdown, Form } from "react-bootstrap";
import LoaderButton from "../../components/Common/LoaderButton";
import { useNavigate } from "react-router-dom";
import { logOut } from "../../redux/Admin/actions/adminAuthActions/authAction";
import { Row, Col } from "react-bootstrap";
function SubscriptionModule() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authData = useSelector((state) => state.adminauth);

  useEffect(() => {
    document.title = "Admin Subscription Module: MinutesVault";
  });

  if (authData.isInValidUser) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/admin-login");
  }

  const [formData, setFormData] = useState({
    planType: "",
    participantLimit: "",
    meetingDuration: "",
    meetingCount: "",
    agendaLimit: "",
    actionablesPerAgenda: "",
    followOnMeetingLimit: "",
    dataRetention: "",
    annualCost: "",
    oneTimeCost: "",
    // billingCycle: "",
    validity: "",
    hosting: "",
    smsGateway: "",
    meta: "",
    smtp: "",
    integrations: "",
    encryption: "",
    isAdmin: false,
  });


  const [errors, setErrors] = useState({});
  const [planType, setPlanType] = useState("");
  const [participantLimit, setParticipantLimit] = useState("");
  const [meetingCount, setMeetingCount] = useState("");
  const [meetingDuration, setMeetingDuration] = useState("");

  // const [billingCycle, setBillingCycle] = useState("");
  const [validity, setValidity] = useState("");
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [id, setid] = useState("");

  const [isConfirming, setIsConfirming] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [subscriptionToDelete, setSubscriptionToDelete] = useState(null);
  console.log();

  // const editSubscriptionValidate = () => {
  //   const errors = {};
  //   const numberRegex = /^[0-9]+$/;

  //   // Plan Type Validation
  //   if (typeof formData.planType === "string" && !formData.planType.trim()) {
  //     errors.planType = "Plan Type is required";
  //   }

  //   // Participant Limit Validation (Must be a number)
  //   if (formData.participantLimit === "" || formData.participantLimit == null) {
  //     errors.participantLimit = "Participant Limit is required";
  //   } else if (!numberRegex.test(formData.participantLimit.toString())) {
  //     errors.participantLimit = "Only numbers are allowed";
  //   }

  //   // Meeting Duration Validation (Must be a number)
  //   if (formData.meetingDuration === "" || formData.meetingDuration == null) {
  //     errors.meetingDuration = "Meeting Duration is required";
  //   } else if (!numberRegex.test(formData.meetingDuration.toString())) {
  //     errors.meetingDuration = "Only numbers are allowed";
  //   }

  //   // Meeting Count Validation (Must be a number)
  //   if (formData.meetingCount === "" || formData.meetingCount == null) {
  //     errors.meetingCount = "Meeting Count is required";
  //   } else if (!numberRegex.test(formData.meetingCount.toString())) {
  //     errors.meetingCount = "Only numbers are allowed";
  //   }

  //   // Price Validation (Must be a valid price format)
  //   if (formData.price === "" || formData.price == null) {
  //     errors.price = "Price is required";
  //   } else if (!/^\d+(\.\d{1,2})?$/.test(formData.price.toString())) {
  //     errors.price = "Invalid price format (e.g., 9.99)";
  //   }

  //   // Billing Cycle Validation
  //   // if (typeof formData.billingCycle === "string" && !formData.billingCycle.trim()) {
  //   //   errors.billingCycle = "Billing Cycle is required";
  //   // }

  //   // Validity Validation (Must be a number)
  //   if (formData.validity === "" || formData.validity == null) {
  //     errors.validity = "Validity is required";
  //   } else if (!numberRegex.test(formData.validity.toString())) {
  //     errors.validity = "Only numbers are allowed";
  //   }

  //   setErrors(errors);
  //   return errors;
  // };

  const editSubscriptionValidate = () => {
    const errors = {};
    const numberRegex = /^[0-9]+$/;

    // Plan Type Validation
    if (typeof formData.planType === "string" && !formData.planType.trim()) {
      errors.planType = "Plan Type is required";
    }

    // Participant Limit Validation (Allow number or "Unlimited")
    if (formData.participantLimit === "" || formData.participantLimit == null) {
      errors.participantLimit = "Participant Limit is required";
    } else if (
      formData.participantLimit.toString().toLowerCase() !== "unlimited" &&
      !numberRegex.test(formData.participantLimit.toString())
    ) {
      errors.participantLimit = "Must be a number or 'Unlimited'";
    }

    // Meeting Duration Validation (Allow number or "Unlimited")
    if (formData.meetingDuration === "" || formData.meetingDuration == null) {
      errors.meetingDuration = "Meeting Duration is required";
    } else if (
      formData.meetingDuration.toString().toLowerCase() !== "unlimited" &&
      !numberRegex.test(formData.meetingDuration.toString())
    ) {
      errors.meetingDuration = "Must be a number or 'Unlimited'";
    }

    // Meeting Count Validation (Allow number or "Unlimited")
    if (formData.meetingCount === "" || formData.meetingCount == null) {
      errors.meetingCount = "Meeting Count is required";
    } else if (
      formData.meetingCount.toString().toLowerCase() !== "unlimited" &&
      !numberRegex.test(formData.meetingCount.toString())
    ) {
      errors.meetingCount = "Must be a number or 'Unlimited'";
    }

    // Price Validation (Must be a valid price format)
    // if (formData.price === "" || formData.price == null) {
    //   errors.price = "Price is required";
    // } else if (!/^\d+(\.\d{1,2})?$/.test(formData.price.toString())) {
    //   errors.price = "Invalid price format (e.g., 9.99)";
    // }

    // Validity Validation (Allow number or "Unlimited")
    if (formData.validity === "" || formData.validity == null) {
      errors.validity = "Validity is required";
    } else if (
      formData.validity.toString().toLowerCase() !== "unlimited" &&
      !numberRegex.test(formData.validity.toString())
    ) {
      errors.validity = "Must be a number or 'Unlimited'";
    }

    setErrors(errors);
    return errors;
  };


  const handleDeleteConfirm = async () => {
    // alert("ok")
    console.log(id);

    try {
      // alert(1);
      if (subscriptionToDelete) {
        //alert(3)
        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL}/api/V1/admin/subscription/deleteSubscription/${id}`
        );
        //alert(2)
        if (response.data.success) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setShowDeleteModal(false);
          setSubscriptionToDelete(null);
          fetchSubscriptions();
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      }
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      console.error("Error while deleting subscription:", error);
    }
  };

  const handleSaveClick = () => {
    const newErrors = editSubscriptionValidate();
    if (Object.keys(newErrors).length === 0) {
      setIsConfirming(true);
    } else {
      setShowEditModal(true);
      setIsConfirming(false);
    }
  };

  const handleEditSave = async (id) => {
    const newErrors = editSubscriptionValidate();
    setIsEditLoading(true);

    if (Object.keys(newErrors).length === 0) {
      try {
        const updatedSubscription = {
          // planType: formData.planType,
          // participantLimit: formData.participantLimit,
          // meetingDuration: formData.meetingDuration,
          // meetingCount: formData.meetingCount,
          // price: formData.price,
          // billingCycle: formData.billingCycle,
          // validity: formData.validity,

          planType: formData.planType,
          participantLimit: formData.participantLimit,
          meetingDuration: formData.meetingDuration,
          meetingCount: formData.meetingCount,
          agendaLimit: formData.agendaLimit,
          actionablesPerAgenda: formData.actionablesPerAgenda,
          followOnMeetingLimit: formData.followOnMeetingLimit,
          dataRetention: formData.dataRetention,
          annualCost: formData.annualCost,
          oneTimeCost: formData.oneTimeCost,
          // billingCycle: formData.billingCycle,
          validity: formData.validity,
          hosting: formData.hosting,
          smsGateway: formData.smsGateway,
          meta: formData.meta,
          smtp: formData.smtp,
          integrations: formData.integrations,
          encryption: formData.encryption,
        };

        const response = await axios.put(
          `${process.env.REACT_APP_API_URL}/api/V1/admin/subscription/updateSubscription/${id}`,
          updatedSubscription,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          fetchSubscriptions();
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setShowEditModal(false);
          fetchSubscriptions();
        } else {
          toast.error(error.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      } catch (error) {
        toast.error(error.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        console.error("Error updating subscription:", error);
      } finally {
        setIsEditLoading(false);
      }
    } else {
      setIsEditLoading(false);
    }
  };

  const handleConfirmSave = () => {
    handleEditSave(id);
    setShowEditModal(false);
    setIsConfirming(false);
  };
  const handleCancel = () => {
    setIsConfirming(false);
  };
  // const handleInputChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   let newValue = type === "checkbox" ? checked : value;

  //   setFormData((prev) => ({ ...prev, [name]: newValue }));

  //   setErrors((prevErrors) => {
  //     let newErrors = { ...prevErrors };

  //     if (name === "planType" && !newValue.trim()) {
  //       newErrors.planType = "Plan Type is required";
  //     } else if (name === "planType") {
  //       delete newErrors.planType;
  //     }

  //     if (
  //       name === "participantLimit" ||
  //       name === "meetingDuration" ||
  //       name === "meetingCount" ||
  //       name === "validity"
  //     ) {
  //       if (!newValue.trim()) {
  //         newErrors[name] = `${name.replace(/([A-Z])/g, " $1")} is required`;
  //       } else if (!/^\d+$/.test(newValue)) {
  //         newErrors[name] = "Only numbers are allowed";
  //       } else {
  //         delete newErrors[name];
  //       }
  //     }

  //     if (name === "price") {
  //       if (!newValue.trim()) {
  //         newErrors.price = "Price is required";
  //       } else if (!/^\d+(\.\d{1,2})?$/.test(newValue)) {
  //         newErrors.price = "Invalid price format (e.g., 9.99)";
  //       } else {
  //         delete newErrors.price;
  //       }
  //     }

  //     // if (name === "billingCycle" && !newValue) {
  //     //   newErrors.billingCycle = "Billing Cycle is required";
  //     // } else if (name === "billingCycle") {
  //     //   delete newErrors.billingCycle;
  //     // }

  //     return newErrors;
  //   });
  // };




  // const validateForm = () => {
  //   let isValid = true;
  //   const errors = {};

  //   // Plan Type Validation
  //   if (typeof formData.planType === "string" && !formData.planType.trim()) {
  //     errors.planType = "Plan Type is required";
  //     isValid = false;
  //   }

  //   // Participant Limits Validation (Must be a number)
  //   if (typeof formData.participantLimit === "string" && !formData.participantLimit.trim()) {
  //     errors.participantLimit = "Participant Limit is required";
  //     isValid = false;
  //   } else if (
  //     isNaN(formData.participantLimit) ||
  //     formData.participantLimit <= 0
  //   ) {
  //     errors.participantLimit = "Enter a valid positive number";
  //     isValid = false;
  //   }

  //   // Meeting Duration Validation (Must be a number)
  //   if (typeof formData.meetingDuration === "string" && !formData.meetingDuration.trim()) {
  //     errors.meetingDuration = "Meeting Duration is required";
  //     isValid = false;
  //   } else if (
  //     isNaN(formData.meetingDuration) ||
  //     formData.meetingDuration <= 0
  //   ) {
  //     errors.meetingDuration = "Enter a valid positive number";
  //     isValid = false;
  //   }

  //   // Meeting Count Validation
  //   if (typeof formData.meetingCount === "string" && !formData.meetingCount.trim()) {
  //     errors.meetingCount = "Meeting Count is required";
  //     isValid = false;
  //   } else if (isNaN(formData.meetingCount) || formData.meetingCount <= 0) {
  //     errors.meetingCount = "Enter a valid positive number";
  //     isValid = false;
  //   }

  //   // Price Validation
  //   if (typeof formData.price === "string" && !formData.price.trim()) {
  //     errors.price = "Price is required";
  //     isValid = false;
  //   } else if (isNaN(formData.price) || formData.price < 0) {
  //     errors.price = "Enter a valid price";
  //     isValid = false;
  //   }

  //   // Billing Cycle Validation
  //   if (typeof formData.billingCycle === "string" && !formData.billingCycle.trim()) {
  //     errors.billingCycle = "Billing Cycle is required";
  //     isValid = false;
  //   }

  //   // Validity Validation
  //   if (typeof formData.validity === "string" && !formData.validity.trim()) {
  //     errors.validity = "Validity is required";
  //     isValid = false;
  //   } else if (isNaN(formData.validity) || formData.validity <= 0) {
  //     errors.validity = "Enter a valid validity period";
  //     isValid = false;
  //   }

  //   setErrors(errors);
  //   return isValid;
  // };

  // const validateForm = () => {
  //   let isValid = true;
  //   const errors = {};

  //   // Plan Type Validation
  //   if (typeof formData.planType === "string" && !formData.planType.trim()) {
  //     errors.planType = "Plan Type is required";
  //     isValid = false;
  //   }

  //   // Participant Limits Validation (Must be a number)
  //   if (formData.participantLimit === "" || formData.participantLimit == null) {
  //     errors.participantLimit = "Participant Limit is required";
  //     isValid = false;
  //   } else if (isNaN(formData.participantLimit) || formData.participantLimit <= 0) {
  //     errors.participantLimit = "Enter a valid positive number";
  //     isValid = false;
  //   }

  //   // Meeting Duration Validation (Must be a number)
  //   if (formData.meetingDuration === "" || formData.meetingDuration == null) {
  //     errors.meetingDuration = "Meeting Duration is required";
  //     isValid = false;
  //   } else if (isNaN(formData.meetingDuration) || formData.meetingDuration <= 0) {
  //     errors.meetingDuration = "Enter a valid positive number";
  //     isValid = false;
  //   }

  //   // Meeting Count Validation
  //   if (formData.meetingCount === "" || formData.meetingCount == null) {
  //     errors.meetingCount = "Meeting Count is required";
  //     isValid = false;
  //   } else if (isNaN(formData.meetingCount) || formData.meetingCount <= 0) {
  //     errors.meetingCount = "Enter a valid positive number";
  //     isValid = false;
  //   }

  //   if (formData.agendaLimit === "" || formData.agendaLimit == null) {
  //     errors.agendaLimit = "Agenda Limit is required";
  //     isValid = false;
  //   } else if (isNaN(formData.agendaLimit) || formData.agendaLimit <= 0) {
  //     errors.agendaLimit = "Enter a valid positive number";
  //     isValid = false;
  //   }

  //   if (formData.actionablesPerAgenda === "" || formData.actionablesPerAgenda == null) {
  //     errors.actionablesPerAgenda = "Actionables PerAgenda is required";
  //     isValid = false;
  //   } else if (isNaN(formData.actionablesPerAgenda) || formData.actionablesPerAgenda <= 0) {
  //     errors.actionablesPerAgenda = "Enter a valid positive number";
  //     isValid = false;
  //   }

  //   if (formData.followOnMeetingLimit === "" || formData.followOnMeetingLimit == null) {
  //     errors.followOnMeetingLimit = "Follow On Meeting Limit is required";
  //     isValid = false;
  //   } else if (isNaN(formData.followOnMeetingLimit) || formData.followOnMeetingLimit <= 0) {
  //     errors.followOnMeetingLimit = "Enter a valid positive number";
  //     isValid = false;
  //   }

  //   if (formData.dataRetention === "" || formData.dataRetention == null) {
  //     errors.dataRetention = "Data Retention is required";
  //     isValid = false;
  //   } else if (isNaN(formData.dataRetention) || formData.dataRetention <= 0) {
  //     errors.dataRetention = "Enter a valid positive number";
  //     isValid = false;
  //   }

  //   if (formData.annualCost === "" || formData.annualCost == null) {
  //     errors.annualCost = "Annual Cost is required";
  //     isValid = false;
  //   } else if (isNaN(formData.annualCost) || formData.annualCost <= 0) {
  //     errors.annualCost = "Enter a valid price";
  //     isValid = false;
  //   }
  //   // Price Validation
  //   if (formData.oneTimeCost === "" || formData.oneTimeCost == null) {
  //     errors.oneTimeCost = "One Time Cost is required";
  //     isValid = false;
  //   } else if (isNaN(formData.oneTimeCost) || formData.oneTimeCost < 0) {
  //     errors.oneTimeCost = "Enter a valid price";
  //     isValid = false;
  //   }

  //   // Billing Cycle Validation
  //   if (typeof formData.billingCycle === "string" && !formData.billingCycle.trim()) {
  //     errors.billingCycle = "Billing Cycle is required";
  //     isValid = false;
  //   }

  //   // Validity Validation
  //   if (formData.validity === "" || formData.validity == null) {
  //     errors.validity = "Validity is required";
  //     isValid = false;
  //   } else if (isNaN(formData.validity) || formData.validity <= 0) {
  //     errors.validity = "Enter a valid validity period";
  //     isValid = false;
  //   }
  //   if (formData.hosting === "" || formData.hosting == null) {
  //     errors.hosting = "Hosting is required";
  //     isValid = false;
  //   } else if (isNaN(formData.hosting) || formData.hosting <= 0) {
  //     errors.hosting = "Enter a valid hosting type.";
  //     isValid = false;
  //   }

  //   setErrors(errors);
  //   return isValid;
  // };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = type === "checkbox" ? checked : value;

    setFormData((prev) => ({ ...prev, [name]: newValue }));

    setErrors((prevErrors) => {
      let newErrors = { ...prevErrors };

      // Plan Type Validation
      if (name === "planType" && !newValue.trim()) {
        newErrors.planType = "Plan Type is required";
      } else if (name === "planType") {
        delete newErrors.planType;
      }

    
      if (
        name === "participantLimit" ||
        name === "meetingDuration" ||
        name === "meetingCount" ||
        name === "validity"
      ) {
        const val = newValue.toString().toLowerCase();

        if (!val.trim()) {
          newErrors[name] = `${name.replace(/([A-Z])/g, " $1")} is required`;
        } else if (val !== "unlimited" && !/^\d+$/.test(val)) {
          newErrors[name] = "Must be a number or 'Unlimited'";
        } else {
          delete newErrors[name];
        }
      }

      // Price Validation
      // if (name === "price") {
      //   if (!newValue.trim()) {
      //     newErrors.price = "Price is required";
      //   } else if (!/^\d+(\.\d{1,2})?$/.test(newValue)) {
      //     newErrors.price = "Invalid price format (e.g., 9.99)";
      //   } else {
      //     delete newErrors.price;
      //   }
      // }

      return newErrors;
    });
  };




  const validateForm = () => {
    let isValid = true;
    const errors = {};

    const isNumberOrUnlimited = (val) => {
      if (typeof val !== "string") val = val?.toString();
      return val?.toLowerCase() === "unlimited" || (!isNaN(val) && Number(val) > 0);
    };

    if (!formData.planType?.trim()) {
      errors.planType = "Plan Type is required";
      isValid = false;
    }

    if (!isNumberOrUnlimited(formData.participantLimit)) {
      errors.participantLimit = "Enter a valid number or 'Unlimited'";
      isValid = false;
    }

    if (!isNumberOrUnlimited(formData.meetingDuration)) {
      errors.meetingDuration = "Enter a valid number or 'Unlimited'";
      isValid = false;
    }

    if (!isNumberOrUnlimited(formData.meetingCount)) {
      errors.meetingCount = "Enter a valid number or 'Unlimited'";
      isValid = false;
    }

    if (!isNumberOrUnlimited(formData.agendaLimit)) {
      errors.agendaLimit = "Enter a valid number or 'Unlimited'";
      isValid = false;
    }

    if (!isNumberOrUnlimited(formData.actionablesPerAgenda)) {
      errors.actionablesPerAgenda = "Enter a valid number or 'Unlimited'";
      isValid = false;
    }

    if (!isNumberOrUnlimited(formData.followOnMeetingLimit)) {
      errors.followOnMeetingLimit = "Enter a valid number or 'Unlimited'";
      isValid = false;
    }

    if (!isNumberOrUnlimited(formData.dataRetention)) {
      errors.dataRetention = "Enter a valid number or 'Unlimited'";
      isValid = false;
    }

    if (formData.annualCost === "" || isNaN(formData.annualCost) || formData.annualCost <= 0) {
      errors.annualCost = "Enter a valid price";
      isValid = false;
    }

    if (formData.oneTimeCost === "" || isNaN(formData.oneTimeCost) || formData.oneTimeCost < 0) {
      errors.oneTimeCost = "Enter a valid price";
      isValid = false;
    }

    if (!isNumberOrUnlimited(formData.validity)) {
      errors.validity = "Enter a valid number or 'Unlimited'";
      isValid = false;
    }

    if (!formData.hosting?.trim()) {
      errors.hosting = "Hosting is required";
      isValid = false;
    }

    if (!formData.smsGateway?.trim()) {
      errors.smsGateway = "Sms Gateway is required";
      isValid = false;
    }

    if (!formData.meta?.trim()) {
      errors.meta = "Meta information is required";
      isValid = false;
    }

    if (!formData.smtp?.trim()) {
      errors.smtp = "SMTP information is required";
      isValid = false;
    }

    if (!formData.integrations?.trim()) {
      errors.integrations = "Please specify integrations";
      isValid = false;
    }

    if (!formData.encryption?.trim()) {
      errors.encryption = "Select an encryption option";
      isValid = false;
    }

    setErrors(errors);
    return isValid;
  };


  const handleDeleteClick = (id) => {
    console.log(id);

    setSubscriptionToDelete(id);

    setShowDeleteModal(true);
    setid(id);
  };

  const handleEditClick = async (subscriptionId) => {
    console.log(subscriptionId);
    setid(subscriptionId);
    try {
      setIsEditLoading(true);

      const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/admin/subscription/subscriptionById/${subscriptionId}`;
      const response = await axios.get(webApiUrl);

      if (response.data && response.data.data) {
        const subscription = response.data.data;
        console.log("subscription", subscription.planType);

        setFormData({
          // planType: subscription.planType,
          // participantLimit: subscription.participantLimit,
          // meetingDuration: subscription.meetingDuration,
          // meetingCount: subscription.meetingCount,
          // meta: subscription.meta,
          // billingCycle: subscription.billingCycle,
          // validity: subscription.validity,

          planType:subscription.planType,
          participantLimit: subscription.participantLimit,
          meetingDuration: subscription.meetingDuration,
          meetingCount: subscription.meetingCount,
          agendaLimit: subscription.agendaLimit,
          actionablesPerAgenda: subscription.actionablesPerAgenda,
          followOnMeetingLimit: subscription.followOnMeetingLimit,
          dataRetention: subscription.dataRetention,
          annualCost: subscription.annualCost,
          oneTimeCost: subscription.oneTimeCost,
          // billingCycle: subscription.,
          validity: subscription.validity,
          hosting: subscription.hosting,
          smsGateway: subscription.smsGateway,
          meta: subscription.meta,
          smtp: subscription.smtp,
          integrations: subscription.integrations,
          encryption: subscription.encryption,
        });

        setShowEditModal(true);
      }
    } catch (error) {
      console.error("Error fetching subscription details:", error);
      // alert("Failed to load subscription details.");
    } finally {
      setIsEditLoading(false);
    }
  };

  const handleChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/admin/subscription/addSubscription`;

        const headerObject = {
          headers: {
            "Content-Type": "application/json",
            // Authorization: accessToken, // Uncomment if needed
          },
        };
        const payload = {
          planType: formData.planType,
          participantLimit: formData.participantLimit,
          meetingDuration: formData.meetingDuration,
          meetingCount: formData.meetingCount,
          agendaLimit: formData.agendaLimit,
          actionablesPerAgenda: formData.actionablesPerAgenda,
          followOnMeetingLimit: formData.followOnMeetingLimit,
          dataRetention: formData.dataRetention,
          annualCost: formData.annualCost,
          oneTimeCost: formData.oneTimeCost,
          // billingCycle: formData.billingCycle,
          validity: formData.validity,
          hosting: formData.hosting,
          smsGateway: formData.smsGateway,
          meta: formData.meta,
          smtp: formData.smtp,
          integrations: formData.integrations,
          encryption: formData.encryption,
        };

        console.log("Payload being sent:", payload);

        const response = await axios.post(webApiUrl, payload, headerObject);

        console.log("API Response:", response);
        if (response.data.success) {
          fetchSubscriptions();
          setFormData({
            planType: "",
            participantLimit: "",
            meetingDuration: "",
            meetingCount: "",
            agendaLimit: "",
            actionablesPerAgenda: "",
            followOnMeetingLimit: "",
            dataRetention: "",
            annualCost: "",
            oneTimeCost: "",
            // billingCycle: "",
            validity: "",
            hosting: "",
            smsGateway: "",
            meta: "",
            smtp: "",
            integrations: "",
            encryption: "",
            isAdmin: false,
          });
          setErrors({});

          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      } catch (error) {
        toast.error(error.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } else {
      console.error("Form validation failed. Please correct the errors.");
    }
  };
  console.log("Subscriptions Data:", subscriptions);

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  const fetchSubscriptions = async () => {
    try {
      const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/admin/subscription/subscriptionsList`;
      const response = await axios.get(webApiUrl);
      console.log("API Response:", response.data); // Debugging

      // Ensure subscriptions is always an array
      setSubscriptions(response.data.data?.result || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
      setError(
        error.response?.data?.message || "Failed to fetch subscriptions."
      );
      setLoading(false);
    }
  };

  return (
    <>
      <AdminHeader />
      <AdminSidebar />
      <div className="main-content"> 
        <div className="Action-list-page">
          <div className="meeting-header-text">
            <h4>Add Subscription</h4>
          </div>
          <div className="mt-2 table-box responsive-table">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* Plan Name */}
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">
                      Plan Name <span className="star-mark">*</span>
                    </label>
                    <input
                      name="planType"
                      type="text"
                      placeholder="Enter Plan Name"
                      className="w-full p-2 border-color rounded"
                      onChange={handleInputChange}
                      value={formData.planType}
                    />
                    {errors.planType && <span className="error-message">{errors.planType}</span>}
                  </div>
                </div>

                {/* Participant Limit */}
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">
                      Participant Limit <span className="star-mark">*</span>
                    </label>
                    <input
                      name="participantLimit"
                      type="text"
                      placeholder="Enter Participant Limit"
                      className="w-full p-2 border-color rounded"
                      onChange={handleInputChange}
                      value={formData.participantLimit}
                    />
                    {errors.participantLimit && <span className="error-message">{errors.participantLimit}</span>}
                  </div>
                </div>

                {/* Meeting Duration */}
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">
                      Meeting Duration (in minutes) <span className="star-mark">*</span>
                    </label>
                    <input
                      name="meetingDuration"
                      type="text"
                      placeholder="Enter Meeting Duration"
                      className="w-full p-2 border-color rounded"
                      onChange={handleInputChange}
                      value={formData.meetingDuration}
                    />
                    {errors.meetingDuration && <span className="error-message">{errors.meetingDuration}</span>}
                  </div>
                </div>

                {/* Meeting Count */}
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">
                      Meeting Count <span className="star-mark">*</span>
                    </label>
                    <input
                      name="meetingCount"
                      type="text"
                      placeholder="Enter Meeting Count"
                      className="w-full p-2 border-color rounded"
                      onChange={handleInputChange}
                      value={formData.meetingCount}
                    />
                    {errors.meetingCount && <span className="error-message">{errors.meetingCount}</span>}
                  </div>
                </div>

                {/* Agenda Limit */}
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">Agenda Limit (per meeting) <span className="star-mark">*</span></label>
                    <input
                      name="agendaLimit"
                      type="text"
                      placeholder="Enter Agenda Limit"
                      className="w-full p-2 border-color rounded"
                      onChange={handleInputChange}
                      value={formData.agendaLimit}
                    />
                    {errors.agendaLimit && <span className="error-message">{errors.agendaLimit}</span>}
                  </div>
                </div>

                {/* Actionables Per Agenda */}
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">Actionables per Agenda <span className="star-mark">*</span></label>
                    <input
                      name="actionablesPerAgenda"
                      type="text"
                      placeholder="Enter No. of Actionables"
                      className="w-full p-2 border-color rounded"
                      onChange={handleInputChange}
                      value={formData.actionablesPerAgenda}
                    />
                    {errors.actionablesPerAgenda && <span className="error-message">{errors.actionablesPerAgenda}</span>}
                  </div>
                </div>

                {/* Follow-On Meetings Limit */}
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">Follow-on Meeting Limit (per meeting) <span className="star-mark">*</span></label>
                    <input
                      name="followOnMeetingLimit"
                      type="text"
                      placeholder="Enter Follow-on Meeting Limit"
                      className="w-full p-2 border-color rounded"
                      onChange={handleInputChange}
                      value={formData.followOnMeetingLimit}
                    />
                    {errors.followOnMeetingLimit && <span className="error-message">{errors.followOnMeetingLimit}</span>}
                  </div>
                </div>

                {/* Data Retention */}
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">Data Retention Period (months) <span className="star-mark">*</span></label>
                    <input
                      name="dataRetention"
                      type="text"
                      placeholder="Enter Retention Period"
                      className="w-full p-2 border-color rounded"
                      onChange={handleInputChange}
                      value={formData.dataRetention}
                    />
                    {errors.dataRetention && <span className="error-message">{errors.dataRetention}</span>}
                  </div>
                </div>

                {/* Annual Cost */}
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">
                      Annual Cost (₹) <span className="star-mark">*</span>
                    </label>
                    <input
                      name="annualCost"
                      type="text"
                      placeholder="Enter Annual Cost"
                      className="w-full p-2 border-color rounded"
                      onChange={handleInputChange}
                      value={formData.annualCost}
                    />
                    {errors.annualCost && <span className="error-message">{errors.annualCost}</span>}
                  </div>
                </div>

                {/* One-Time Cost */}
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">One-Time Cost (₹) <span className="star-mark">*</span></label>
                    <input
                      name="oneTimeCost"
                      type="text"
                      placeholder="Enter One-Time Cost"
                      className="w-full p-2 border-color rounded"
                      onChange={handleInputChange}
                      value={formData.oneTimeCost}
                    />
                    {errors.oneTimeCost && <span className="error-message">{errors.oneTimeCost}</span>}
                  </div>
                </div>

                {/* Billing Cycle */}
                {/* <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">
                      Billing Cycle <span className="star-mark">*</span>
                    </label>
                    <select
                      name="billingCycle"
                      className="w-full p-2 border-color rounded"
                      onChange={handleInputChange}
                      value={formData.billingCycle}
                    >
                      <option value="">-- Select --</option>
                      <option value="monthly">Monthly</option>
                      <option value="yearly">Yearly</option>
                      <option value="3year">3-Year</option>
                    </select>
                    {errors.billingCycle && <span className="error-message">{errors.billingCycle}</span>}
                  </div>
                </div> */}

                {/* Validity */}
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">
                      Validity (in days) <span className="star-mark">*</span>
                    </label>
                    <input
                      name="validity"
                      type="text"
                      placeholder="Enter Validity"
                      className="w-full p-2 border-color rounded"
                      onChange={handleInputChange}
                      value={formData.validity}
                    />
                    {errors.validity && <span className="error-message">{errors.validity}</span>}
                  </div>
                </div>

                {/* Hosting */}
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">Hosting <span className="star-mark">*</span></label>
                    <input
                      name="hosting"
                      type="text"
                      placeholder="Enter Hosting Info"
                      className="w-full p-2 border-color rounded"
                      onChange={handleInputChange}
                      value={formData.hosting}
                    />
                    {errors.hosting && <span className="error-message">{errors.hosting}</span>}
                  </div>
                </div>

                {/* SMS Gateway */}
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">SMS Gateway <span className="star-mark">*</span></label>
                    <input
                      name="smsGateway"
                      type="text"
                      placeholder="Enter SMS Gateway Info"
                      className="w-full p-2 border-color rounded"
                      onChange={handleInputChange}
                      value={formData.smsGateway}
                    />
                    {errors.smsGateway && <span className="error-message">{errors.smsGateway}</span>}
                  </div>
                </div>

                {/* Meta */}
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">Meta <span className="star-mark">*</span></label>
                    <input
                      name="meta"
                      type="text"
                      placeholder="Enter Meta Info"
                      className="w-full p-2 border-color rounded"
                      onChange={handleInputChange}
                      value={formData.meta}
                    />
                    {errors.meta && <span className="error-message">{errors.meta}</span>}
                  </div>
                </div>

                {/* SMTP */}
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">SMTP <span className="star-mark">*</span></label>
                    <input
                      name="smtp"
                      type="text"
                      placeholder="Enter SMTP Info"
                      className="w-full p-2 border-color rounded"
                      onChange={handleInputChange}
                      value={formData.smtp}
                    />
                    {errors.smtp && <span className="error-message">{errors.smtp}</span>}
                  </div>
                </div>

                {/* Integrations */}
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">Integrations <span className="star-mark">*</span></label>
                    <input
                      name="integrations"
                      type="text"
                      placeholder="e.g. Google Calendar, Zoom"
                      className="w-full p-2 border-color rounded"
                      onChange={handleInputChange}
                      value={formData.integrations}
                    />
                    {errors.integrations && <span className="error-message">{errors.integrations}</span>}
                  </div>
                </div>

                {/* Encryption */}
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">Encryption <span className="star-mark">*</span></label>
                    <select
                      name="encryption"
                      className="w-full p-2 border-color rounded"
                      onChange={handleInputChange}
                      value={formData.encryption}
                    >
                      <option value="">-- Select Encryption --</option>
                      <option value="none">None</option>
                      <option value="AES-256">AES-256</option>
                      <option value="end-to-end">End-to-End</option>
                    </select>
                  </div>
                  {errors.encryption && <span className="error-message">{errors.encryption}</span>}
                </div>
              </div>

              <button className="create-meeting-button Mom-btn mt-3">
                <p>Submit</p>
              </button>
            </form>


          </div>
        </div>

        <div className="Action-list-page">
          <div className="meeting-header-text mt-4">
            <h4>Manage Subscription</h4>
          </div>
          <div className="mt-2 table-box responsive-table">
            <div className="row">
              {subscriptions.map((plan) => (
                <div key={plan._id} className="col-md-4 plan">
                  <div className="feature-plan-card carousel-plan-card basic-plan-card plain-btn-plan">
                    <section className="plan-price__info">
                      <h3 id={plan.planType} className="title">
                        <div className="title-words">
                          {plan.planType.charAt(0).toUpperCase() + plan.planType.slice(1)}
                          <span className="users-text">{plan.participantLimit} users</span>
                        </div>
                      </h3>

                      <div className="both-price-wrapper both-wrapper-mobile pro">
                        <div className="price-info">
                          <span aria-label=""></span>

                          {/* Displaying One-Time Cost with Monthly Tag */}
                          <div className="price-info__year">
                            <span className="subtext currency-vnd-flag">₹</span>
                            <div className="price-num">
                              {plan.oneTimeCost === 0 ? "Free" : <>{plan.oneTimeCost}</>}
                              <span className="flag-hidden"></span>
                              <span className="subtext">/monthly</span> {/* Adding /monthly */}
                            </div>
                          </div>

                          {/* Displaying Annual Cost with Yearly Tag */}
                          {plan.annualCost > 0 && (
                            <div className="price-info__year">
                              <span className="subtext currency-vnd-flag">₹</span>
                              <div className="price-num">
                                {plan.annualCost === 0 ? "Free" : <>{plan.annualCost}</>}
                                <span className="flag-hidden"></span>
                                <span className="subtext" style={{
                                  // left: "118px",
                                  // marginBottom: "20px",
                                  // position: "absolute",
                                  color: "rgb(0, 5, 61)",
                                }}>/yearly</span>
                              </div>
                            </div>
                          )}

                          <div className="price-info__label">
                            {/* <div
        className="price-info__label-year price-more-explain-limit-monthly-average"
        style={{
          left: "96.2188px",
          marginTop: "-35px",
          position: "absolute",
          color: "rgb(0, 5, 61)",
        }}
      >
        /{plan.billingCycle}
      </div> */}
                          </div>
                        </div>
                      </div>


                    </section>

                    <div className="introduction">
                      <ul className="introduce-features">
                        {/* Existing Fields */}
                        <li className="new-plan-feature-item new-plan-feature-item-warp">
                          <p className="feature-title">
                            <div className="zm-tooltip toolTips-word toolTips-word-mobile">
                              Meeting Duration
                            </div>
                            <span className="desc">{plan.meetingDuration} minutes per meeting</span>
                          </p>
                        </li>
                        <li className="new-plan-feature-item new-plan-feature-item-warp">
                          <p className="feature-title">
                            <div className="zm-tooltip toolTips-word toolTips-word-mobile">
                              {plan.participantLimit} Participants
                            </div>
                            <span className="desc">per meeting</span>
                          </p>
                        </li>
                        <li className="new-plan-feature-item new-plan-feature-item-warp">
                          <p className="feature-title">
                            <div className="zm-tooltip toolTips-word toolTips-word-mobile">
                              Total Meetings
                            </div>
                            <span className="desc">{plan.meetingCount} meetings</span>
                          </p>
                        </li>
                        <li className="new-plan-feature-item new-plan-feature-item-warp">
                          <p className="feature-title">
                            <div className="zm-tooltip toolTips-word toolTips-word-mobile">
                              Validity
                            </div>
                            <span className="desc">{plan.validity} Days</span>
                          </p>
                        </li>
                        <li className="new-plan-feature-item new-plan-feature-item-warp">
                          <p className="feature-title">
                            <div className="zm-tooltip toolTips-word toolTips-word-mobile">
                              Agenda Limit
                            </div>
                            <span className="desc">{plan.agendaLimit} agendas</span>
                          </p>
                        </li>
                        <li className="new-plan-feature-item new-plan-feature-item-warp">
                          <p className="feature-title">
                            <div className="zm-tooltip toolTips-word toolTips-word-mobile">
                              Actionables Per Agenda
                            </div>
                            <span className="desc">{plan.actionablesPerAgenda} actionables</span>
                          </p>
                        </li>
                        <li className="new-plan-feature-item new-plan-feature-item-warp">
                          <p className="feature-title">
                            <div className="zm-tooltip toolTips-word toolTips-word-mobile">
                              Follow-On Meeting Limit
                            </div>
                            <span className="desc">{plan.followOnMeetingLimit} meetings</span>
                          </p>
                        </li>
                        <li className="new-plan-feature-item new-plan-feature-item-warp">
                          <p className="feature-title">
                            <div className="zm-tooltip toolTips-word toolTips-word-mobile">
                              Hosting
                            </div>
                            <span className="desc">{plan.hosting}</span>
                          </p>
                        </li>

                        {/* ✅ New Fields From Backend Response */}
                        <li className="new-plan-feature-item new-plan-feature-item-warp">
                          <p className="feature-title">
                            <div className="zm-tooltip toolTips-word toolTips-word-mobile">
                              SMTP
                            </div>
                            <span className="desc">{plan.smtp}</span>
                          </p>
                        </li>

                        <li className="new-plan-feature-item new-plan-feature-item-warp">
                          <p className="feature-title">
                            <div className="zm-tooltip toolTips-word toolTips-word-mobile">
                              Meta
                            </div>
                            <span className="desc">{plan.meta}</span>
                          </p>
                        </li>

                        <li className="new-plan-feature-item new-plan-feature-item-warp">
                          <p className="feature-title">
                            <div className="zm-tooltip toolTips-word toolTips-word-mobile">
                              Integrations
                            </div>
                            <span className="desc">{plan.integrations}</span>
                          </p>
                        </li>

                        <li className="new-plan-feature-item new-plan-feature-item-warp">
                          <p className="feature-title">
                            <div className="zm-tooltip toolTips-word toolTips-word-mobile">
                              Encryption
                            </div>
                            <span className="desc">{plan.encryption}</span>
                          </p>
                        </li>

                        <li className="new-plan-feature-item new-plan-feature-item-warp">
                          <p className="feature-title">
                            <div className="zm-tooltip toolTips-word toolTips-word-mobile">
                              SMS Gateway
                            </div>
                            <span className="desc">{plan.smsGateway}</span>
                          </p>
                        </li>

                        <li className="new-plan-feature-item new-plan-feature-item-warp">
                          <p className="feature-title">
                            <div className="zm-tooltip toolTips-word toolTips-word-mobile">
                              Data Retention
                            </div>
                            <span className="desc">{plan.dataRetention} months</span>
                          </p>
                        </li>
                      </ul>

                    </div>

                    {/* Edit & Delete Buttons */}
                    <div className="plan-actions">
                      <button
                        className="btn rounded-pill add-btn Mom-btn d-flex align-items-center justify-content-center"
                        style={{ textDecoration: "none", color: "white" }}
                        onClick={() => handleEditClick(plan._id)}
                      >
                        Edit
                      </button>
                      <button
                        className="create-meeting-button Mom-btn"
                        onClick={() => handleDeleteClick(plan._id)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <Modal
              show={showEditModal}
              onHide={() => setShowEditModal(false)}
              // backdrop="static"
              centered
              size="lg"
            >
              <Modal.Header closeButton>
                <Modal.Title>Edit Subscription</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="form-group">
                        <Form.Label className="mb-1">
                          Plan Name<span className="star-mark"> *</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="planType"
                          value={formData.planType}
                          onChange={(e) => handleChange("planType", e.target.value)}
                          disabled
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="form-group">
                        <Form.Label>Participant Limit <span className="star-mark"> *</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="participantLimit"
                          value={formData.participantLimit || ""}
                          onChange={(e) =>
                            handleChange("participantLimit", e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="form-group">
                        <Form.Label>Meeting Duration (in minutes) <span className="star-mark"> *</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="meetingDuration"
                          value={formData.meetingDuration || ""}
                          onChange={(e) =>
                            handleChange("meetingDuration", e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="form-group">
                        <Form.Label>Meeting Count  <span className="star-mark"> *</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="meetingCount"
                          value={formData.meetingCount || ""}
                          onChange={(e) =>
                            handleChange("meetingCount", e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="form-group">
                        <Form.Label>Agenda Limit (per meeting)  <span className="star-mark"> *</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="agendaLimit"
                          value={formData.agendaLimit || ""}
                          onChange={(e) =>
                            handleChange("agendaLimit", e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="form-group">
                        <Form.Label>Actionables per Agenda  <span className="star-mark"> *</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="actionablesPerAgenda"
                          value={formData.actionablesPerAgenda || ""}
                          onChange={(e) =>
                            handleChange("actionablesPerAgenda", e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="form-group">
                        <Form.Label>Follow-on Meeting Limit (per meeting)  <span className="star-mark"> *</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="followOnMeetingLimit"
                          value={formData.followOnMeetingLimit || ""}
                          onChange={(e) =>
                            handleChange("followOnMeetingLimit", e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="form-group">
                        <Form.Label>Data Retention (in days) <span className="star-mark"> *</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="dataRetention"
                          value={formData.dataRetention || ""}
                          onChange={(e) =>
                            handleChange("dataRetention", e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="form-group">
                        <Form.Label>Annual Cost (₹)  <span className="star-mark"> *</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="annualCost"
                          value={formData.annualCost || ""}
                          onChange={(e) =>
                            handleChange("annualCost", e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="form-group">
                        <Form.Label>One-Time Cost (₹) <span className="star-mark"> *</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="oneTimeCost"
                          value={formData.oneTimeCost || ""}
                          onChange={(e) =>
                            handleChange("oneTimeCost", e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="form-group">
                        <Form.Label>Validity (days) <span className="star-mark"> *</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="validity"
                          value={formData.validity || ""}
                          onChange={(e) =>
                            handleChange("validity", e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="form-group">
                        <Form.Label>Hosting  <span className="star-mark"> *</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="hosting"
                          value={formData.hosting || ""}
                          onChange={(e) =>
                            handleChange("hosting", e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="form-group">
                        <Form.Label>SMS Gateway  <span className="star-mark"> *</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="smsGateway"
                          value={formData.smsGateway || ""}
                          onChange={(e) =>
                            handleChange("smsGateway", e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="form-group">
                        <Form.Label>Meta <span className="star-mark"> *</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="meta"
                          value={formData.meta || ""}
                          onChange={(e) =>
                            handleChange("meta", e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="form-group">
                        <Form.Label>SMTP <span className="star-mark"> *</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="smtp"
                          value={formData.smtp || ""}
                          onChange={(e) =>
                            handleChange("smtp", e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="form-group">
                        <Form.Label>Integrations <span className="star-mark"> *</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="integrations"
                          value={formData.integrations || ""}
                          onChange={(e) =>
                            handleChange("integrations", e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="form-group">
                        <Form.Label>Encryption <span className="star-mark"> *</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="encryption"
                          value={formData.encryption || ""}
                          onChange={(e) =>
                            handleChange("encryption", e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>

                  </Row>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                {isConfirming ? (
                  <>
                    <Button
                      variant=""
                      className="add-minutes Mom-btn"
                      onClick={handleCancel}
                    >
                      <p>Cancel</p>
                    </Button>
                    <Button
                      variant=""
                      className="create-meeting-button Mom-btn "
                      onClick={handleConfirmSave()}
                    >
                      <p> Confirm Update</p>
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant=""
                      className="add-minutes Mom-btn"
                      onClick={() => setShowEditModal(false)}
                    >
                      <p>Close</p>
                    </Button>
                    {isEditLoading ? (
                      <LoaderButton />
                    ) : (
                      <Button
                        variant=""
                        className="create-meeting-button Mom-btn"
                        onClick={handleSaveClick}
                      >
                        <p>Save Changes</p>
                      </Button>
                    )}
                  </>
                )}
              </Modal.Footer>
            </Modal>
            <Modal
              show={showDeleteModal}
              onHide={() => setShowDeleteModal(false)}
              backdrop="static"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Confirm Delete</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Are you sure you want to delete this Subscription?
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant=""
                  className="add-minutes Mom-btn"
                  onClick={handleDeleteConfirm}
                >
                  <p>Delete</p>
                </Button>
                <Button
                  variant=""
                  className="add-minutes Mom-btn"
                  onClick={() => setShowDeleteModal(false)}
                >
                  <p>Cancel</p>
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
}

export default SubscriptionModule;
